import { render, staticRenderFns } from "./booking_dashboard_shell.vue?vue&type=template&id=d1254494&scoped=true&"
import script from "./booking_dashboard_shell.vue?vue&type=script&lang=js&"
export * from "./booking_dashboard_shell.vue?vue&type=script&lang=js&"
import style0 from "./booking_dashboard_shell.vue?vue&type=style&index=0&id=d1254494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1254494",
  null
  
)

export default component.exports